/** The card beside the canvas that every inspector draws in. */
import type { ReactNode } from 'react';

export function InspectorPanel({ children }: { children: ReactNode }) {
  return (
    <aside
      aria-label="Inspector"
      data-tour="inspector"
      style={{
        border: '1px solid var(--border-hairline)',
        borderRadius: 'var(--radius-card)',
        background: 'var(--surface-card)',
        padding: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 14,
        alignSelf: 'flex-start',
        maxHeight: 640,
        overflowY: 'auto',
      }}
    >
      {children}
    </aside>
  );
}
